// extracted by mini-css-extract-plugin
module.exports = {"TagContainerFull":"TagContainerFull__30WfN","TagContainerHidden":"TagContainerHidden__3Lyti"};